import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../root.reducer";

const selectAppLogState = (state: RootState) => state.appLogs;

export const getAppLogState = createSelector(
    [selectAppLogState],
    (state) => state
);

export const getAppLogList = createSelector(
    [selectAppLogState],
    (state) => ({
        appLogs: state?.appLogs || { data: [], pagination: {} },
        loading: state?.listLoading || false,
        appendLoading: state?.appendLoading || false,
        downloadInProgress: state?.downloadLoading,
        downloadError: state?.downloadError ?? null,
    })
);
